import React, { useContext, useEffect, useState } from 'react';
import maps_rojo from '../../images/maps_rojos.png';
import ubicacion_jhimbop from '../../images/ubicacion-jhimbo.png';
import { Remove } from "@mui/icons-material";
import { returnFullURL } from '../../components';
import LocationIcon from '../../svg/LocationIcon';

export const VisitasUbicacion = ({ infoCompany, company_name }) => {
    const branch_selected = infoCompany?.branchs ?? [];

    const {
        img_url: coverImg = null,
        text: descripcion = 'valorPorDefectoTexto',
        title: encabezado = 'valorPorDefectoTitulo'
    } = infoCompany?.view3 ?? {};

    const [current_branch, setCurrentBranchs] = useState(branch_selected[0] ?? {});

    // Asegúrate de que el estado se actualice si `infoCompany.branchs` cambia
    useEffect(() => {
        if (branch_selected.length > 0) {
            setCurrentBranchs(branch_selected[0]); // Establece el primer valor por defecto
        }
    }, [branch_selected]);

    return (
        <>
            <div className='our-ubication'>
                <div className='title-jhimbo-content'>
                    <div className='title-ubication-jhimbo'>
                        <div className='back-jhimbo'><h3 style={{ color: 'var(--theme-visit)' }}>{company_name ?? "Dato invalido"}</h3></div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Remove fontSize="large" />

                            <select
                                style={{ fontSize: 'clamp(0.7rem, 2vw, 1.5rem)', borderRadius: '7px', backgroundColor: 'transparent', color: '#fff', fontWeight: '500', padding: '5px' }}
                                onClick={(item) => { setCurrentBranchs(branch_selected[item.target.value]) }}
                            >
                                {
                                    branch_selected.map((data, index) => (
                                        <option style={{ backgroundColor: 'transparent', border: 'none', color: '#000' }} value={index} selected={index === 0}>{data.fullName}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                    <div><h2><span style={{ color: 'var(--theme-visit)' }}>Nuestra</span> Ubicación</h2></div>
                </div>
                <div className='view-ubication'>
                    <div className='location-information'>
                        <div>
                            <div className='head-location-information'>
                                <LocationIcon color='#e50027' main_css={{ width: '30px' }} />
                                <span style={{ width: '100%', border: '3px solid var(--theme-visit)' }}></span>
                                <h2>{current_branch?.locality_text ?? "Información del local:"}</h2>
                            </div>

                            <div className='location-schedule'>
                                <h2>HORARIO DE ATENCIÓN</h2>
                                <div className='back-azul' style={{ backgroundColor: 'var(--theme-visit)' }}>
                                    <span>Horario Continuo</span>
                                </div>
                                <h3>{current_branch.day_ini ?? "Lunes"} a {current_branch.day_Fin ?? "Lunes"}</h3>
                                <h3>{current_branch.time_range ?? "Sin Definir"}</h3>
                                <div className='clockContainer'>
                                    <div className="clock" style={{backgroundColor:'var(--theme-visit)'}}>
                                        <div className="face"></div>
                                        <div className="hour hand"></div>
                                        <div className="minute hand"></div>
                                        <div className="cover"></div>
                                        <div className="second-bulb"></div>
                                        <div className="second hand"></div>
                                        <div className="number">8</div>
                                        <div className="number">6</div>
                                    </div>
                                </div>
                                <h3>{current_branch.particular_day ?? "Sabado"}</h3>
                                <h3>{current_branch.particular_time ?? "Sin Definir"}</h3>
                            </div>

                            <span style={{ width: '100%', border: '3px solid var(--theme-visit)', marginTop: '1rem' }}></span>
                        </div>


                        <div>
                            <iframe src={`http://maps.google.com/maps?q=${current_branch?.lat ?? '-17.7812221'},${current_branch?.lon ?? '-63.1797761'}&output=embed`} style={{ width: '90%', height: '80%' }}></iframe>
                        </div>
                    </div>

                    <div className='cover-ubication'>
                        <div style={{ backgroundColor: 'var(--theme-visit)' }}> </div>
                        <img src={returnFullURL(coverImg, "picture")} alt="ubicacion" />
                    </div>
                </div>
            </div>

            <div className="mobile-ubicacion-container">
                <div className="mobile-title">
                    <div className="mobile-header">
                        <div className='back-jhimbo'><h3 style={{ color: 'var(--theme-visit)' }}>{company_name ?? "Dato invalido"}</h3></div>
                        {/* <span style={{ color: '#fff' }}> Tienda Central</span> */}

                        <select
                            style={{ fontSize: '1.2remp', borderRadius: '7px', backgroundColor: 'transparent', color: '#fff', fontWeight: '500', padding: '3px' }}
                            onClick={(item) => { setCurrentBranchs(branch_selected[item.target.value]) }}
                        >
                            {
                                branch_selected.map((data, index) => (
                                    <option style={{ backgroundColor: 'transparent', border: 'none', color: '#000' }} value={index} selected={index === 0}>{data.fullName}</option>
                                ))
                            }
                        </select>
                    </div>
                    <h2><span style={{ color: 'var(--theme-visit)' }}>Nuestra Ubicación</span></h2>
                </div>

                <div className="mobile-location">
                    <img src={maps_rojo} alt="map" style={{ height: '24px', width: '28px' }} />
                    <h2 style={{ color: '#fff', fontSize: '16px', margin: 0 }}>
                        {current_branch?.locality_text ?? "Información del local:"}
                    </h2>
                </div>

                <div className="mobile-schedule">
                    <h2>HORARIO DE ATENCIÓN</h2>
                    <div className='back-azul' style={{ backgroundColor: 'var(--theme-visit)' }}>
                        <span>Horario Continuo</span>
                    </div>
                    <h3>{current_branch.day_ini ?? "Lunes"} a {current_branch.day_Fin ?? "Lunes"}</h3>
                    <h3>{current_branch.time_range ?? "Sin Definir"}</h3>
                    <div className='clockContainer'>
                        <div className="clock" style={{backgroundColor:'var(--theme-visit)'}}>
                            <div className="face"></div>
                            <div className="hour hand"></div>
                            <div className="minute hand"></div>
                            <div className="cover"></div>
                            <div className="second-bulb"></div>
                            <div className="second hand"></div>
                            <div className="number">8</div>
                            <div className="number">6</div>
                        </div>
                    </div>
                    <h3>{current_branch.particular_day ?? "Sabado"}</h3>
                    <h3>{current_branch.particular_time ?? "Sin Definir"}</h3>
                </div>

                <div className="mobile-map">
                    <iframe src={`http://maps.google.com/maps?q=${current_branch?.lat ?? '-17.7812221'},${current_branch?.lon ?? '-63.1797761'}&output=embed`} style={{ width: '93vw', height: '45vh' }}></iframe>
                </div>

                <img src={ubicacion_jhimbop}
                    alt="ubicacion"
                    style={{ width: '100%', borderRadius: '8px' }}
                    className={`jhimbo-pic`} />
            </div >
        </>
    )
}
